import { lazy } from 'react';

const InvoicedAdmConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/adm/material/invoiced-info',
			component: lazy(() => import('./InvoicedContainer'))
		}
	]
};

export default InvoicedAdmConfig;

